import { render, staticRenderFns } from "./didStartWorkAgain.vue?vue&type=template&id=fa50b0a0"
import script from "./didStartWorkAgain.vue?vue&type=script&lang=js"
export * from "./didStartWorkAgain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports